export const headerTextStyle = {
  color: "#404040",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
  fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
};

export const headerLastTextStyle = {
  color: "#404040",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 700,
  fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
};

export const display3Style = {
  fontSize: "26px",
  lineHeight: "32px",
  fontWeight: 800,
  fontFamily: "MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif",
};
